import React, { Component } from 'react';
import Utils from '../../utils.js'

class Summary extends Component {
	
	//lambda ensures correct 'this' scope
	onSubmit = (e) => {
		let data = this.props.getStore();
		let url = 'https://build.ris.principal.com/job/DeveloperUtils/job/WAS_Deployers_RIS_T/job/apigateway/job/createNewConsumer/parambuild/?delay=0sec';
		url += '&subBU=' + encodeURIComponent(data.subBU);
		url += '&consumerName=' + encodeURIComponent(Utils.constructProxyGroupPrefix(data.subBU) + data.consumerName);
		url += '&gitUrl=' + encodeURIComponent(data.gitURL);
		url += '&pfgSignOnRequired=' + encodeURIComponent((undefined===data.pfgSignOn ? "false" : String(data.pfgSignOn)));
		url += '&pfgSignOnType=' + encodeURIComponent((undefined===data.pfgSignOnType ? "NONE" : String(data.pfgSignOnType)));
		window.location.href = url;
	}
	
	render() {
		let data = this.props.getStore();
		return <div>
			<div className="container util-margin-top-50">
				<div className="row">
					<div className="col-md-3">
						<span>Consumer Name: </span>
					</div>
					<div className="col-md-6">
						<span>{Utils.constructProxyGroupPrefix(data.subBU) + data.consumerName}</span>
					</div>
				</div>
				<hr/>
				<div className="row">
					<div className="col-md-3">
						<span>Git URL: </span>
					</div>
					<div className="col-md-6">
						<span>{data.gitURL}</span>
					</div>
				</div>
				<hr/>
				<div className="row">
					<div className="col-md-3">
						<span>PFG SignOn Required: </span>
					</div>
					<div className="col-md-6">
						<span>{String(!!data.pfgSignOn)}</span>
					</div>
				</div>
				{data.pfgSignOnType!=='NONE' &&
				<div>
				<hr/>
				<div className="row">
					<div className="col-md-3">
						<span>PFG SignOn Type: </span>
					</div>
					<div className="col-md-6">
						<span>{String(data.pfgSignOnType)}</span>
					</div>
				</div>
				</div>
				}
			<hr/>
			</div>
			<div>
				<button className="btn btn-primary btn-sm pull-right util-margin-top-50" onClick={this.onSubmit}>Submit</button>
			</div>
		</div>
	}
}

export default Summary;